export class EnvironmentProvider {
    logLevel: string;
    pisBaseUrl: string;
    posBaseUrl: string;
    env: string;

    constructor() {
        this.logLevel = this.getEnvironmentVariable('LOG_LEVEL') || 'WARN';
        this.pisBaseUrl = this.getEnvironmentVariable('PIS_BASE_URL') || '';
        this.posBaseUrl = this.getEnvironmentVariable('POS_BASE_URL') || '';
        this.env = this.getEnvironmentVariable('NAME') || '';
    }

    getEnvironmentVariable = (variableName: string): string | undefined => {
        return process.env[`REACT_APP_${variableName}`];
    };

    isProductionBuild(): boolean {
        return this.env === 'production';
    }
}
const environment = new EnvironmentProvider();
export default environment;
